import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDownIcon, SearchIcon, ShoppingCartIcon } from 'lucide-react';
import { useSession } from '../contexts/SessionContext';
import { primaryNav } from '../data/site';
export function SiteHeader() {
  const {
    isLoggedIn,
    firstName,
    cartCount,
    logout
  } = useSession();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  return <header className="relative z-20 w-full bg-white" data-id="element-183" data-mp="v0bnctiy2qpf">
      <Link to="/" className="absolute left-4 top-2 z-10 block" aria-label="i9 Sports home" data-id="element-184" data-mp="qxfdpsbdu4xm">
        <img src="https://cdn.magicpatterns.com/uploads/4egNXSEskxSbdFkWAP1Y3M/I9_Logo_Hi_Res_Multicolor.png" alt="i9 Sports" className="h-[80px] w-auto" data-id="element-185" data-mp="14wor6k87ekxw" />
      </Link>

      <nav aria-label="Primary" className="flex h-[60px] items-center justify-end pr-8" data-id="element-186" data-mp="2gaistw69xpu3">
        <ul className="hidden items-center gap-10 lg:flex" data-id="element-187" data-mp="2bda8boxnl9po">
          {primaryNav.map(item => <li key={item.label} data-id="element-188" data-mp="29kljv94mf3xe">
              <Link to={item.to} className="flex items-center gap-1 text-[15px] font-semibold uppercase text-navy transition-colors duration-150 hover:text-brand-red" data-id="element-189" data-mp="29jajljadweb1">
                {item.label}
                {item.hasMenu && <ChevronDownIcon className="h-4 w-4" aria-hidden data-id="element-190" data-mp="2ohcktmty0np4" />}
              </Link>
            </li>)}
        </ul>
      </nav>

      <div className="flex h-[42px] items-center bg-navy pl-48 text-white" data-id="element-191" data-mp="1qv5i6ih795fe">
        <form className="hidden items-center gap-6 md:flex" onSubmit={e => e.preventDefault()} role="search" data-id="element-192" data-mp="1vt70h16sx0pt">
          <label htmlFor="header-zip" className="whitespace-nowrap text-[15px] font-bold uppercase tracking-wide" data-id="element-193" data-mp="20pxgxpmipybr">
            Find a program near you
          </label>
          <div className="flex" data-id="element-194" data-mp="183me08bfvlbs">
            <input id="header-zip" defaultValue={isLoggedIn ? '33023' : ''} placeholder="ZIP Code" className="h-8 w-24 rounded-l border border-white px-2 text-navy outline-none focus:ring-2 focus:ring-brand-sky" data-id="element-195" data-mp="182krn7oz3cer" />
            <button type="submit" aria-label="Search programs" className="flex h-8 w-10 items-center justify-center rounded-r bg-brand-red transition-colors duration-150 hover:bg-brand-red-dark" data-id="element-196" data-mp="101df4cl44qg8">
              <SearchIcon className="h-4 w-4" data-id="element-197" data-mp="19t9ers2ukomk" />
            </button>
          </div>
        </form>

        <div className="ml-auto flex h-full items-center text-[15px]" data-id="element-198" data-mp="m35bxmxhgswm">
          {isLoggedIn ? <>
              <Link to="/dashboard" className="hidden h-full items-center px-5 transition-colors duration-150 hover:bg-navy-deep xl:flex" data-id="element-199" data-mp="h4u57l2hiyim">
                Dashboard
              </Link>
              <span className="hidden h-full items-center gap-1 px-5 xl:flex" data-id="element-200" data-mp="r0noroemfs9w">
                My Season <ChevronDownIcon className="h-4 w-4" aria-hidden data-id="element-201" data-mp="27enn4uxtj9v1" />
              </span>
              <span className="hidden h-full items-center gap-1 px-5 xl:flex" data-id="element-202" data-mp="22hez4dpzoblv">
                My Account <ChevronDownIcon className="h-4 w-4" aria-hidden data-id="element-203" data-mp="29zljy5onajy6" />
              </span>
              <span className="hidden h-full items-center bg-brand-red px-5 [clip-path:polygon(8%_0,100%_0,92%_100%,0_100%)] lg:flex" data-id="element-204" data-mp="2eyy7ytr95x2c">
                Franchise Info
              </span>
              <span className="hidden whitespace-nowrap px-5 sm:block" data-id="element-205" data-mp="2511y05a1x85t">Welcome, {firstName}</span>
              <span className="flex items-center gap-2 px-3" data-id="element-206" data-mp="2sqmhqqe149g5">
                <span className="flex h-6 min-w-6 items-center justify-center rounded-full bg-[#0C5D9E] px-2 text-sm" data-id="element-207" data-mp="2sr5za5zrovtn">{cartCount}</span>
                <ShoppingCartIcon className="h-4 w-4" aria-hidden data-id="element-208" data-mp="2jyasv8ykcu2a" />
                <span className="hidden sm:inline" data-id="element-209" data-mp="2jy2e1bivreog">Cart</span>
              </span>
              <button onClick={handleLogout} className="mx-3 h-[36px] rounded bg-brand-red px-3 text-[16px] transition-colors duration-150 hover:bg-brand-red-dark" data-id="element-210" data-mp="2nyl7tb4c2uta">
                Logout
              </button>
            </> : <>
              <Link to="/login" className="flex h-full items-center gap-1 whitespace-nowrap px-5 transition-colors duration-150 hover:bg-navy-deep" data-id="element-211" data-mp="1stgln0muf19z">
                Login / Sign up <ChevronDownIcon className="h-4 w-4" aria-hidden data-id="element-212" data-mp="1it679cp2nnt8" />
              </Link>
              <span className="mr-4 hidden h-full items-center bg-brand-red px-6 [clip-path:polygon(8%_0,100%_0,92%_100%,0_100%)] sm:flex" data-id="element-213" data-mp="1esdy0jg79iwy">
                Franchise Info
              </span>
            </>}
        </div>
      </div>
    </header>;
}